import {
  navigateTo,
  useHead,
  useRequestURL,
  useRoute,
  useRouter,
} from '#imports'

import type { BuybackProduct } from '@backmarket/nuxt-layer-buyback/app/scopes/offer/api/types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { ROUTE_NAMES } from '~/scopes/buyback/constants'

import translations from './useSeoProductPageHead.translations'

export async function useSeoProductPageHead(product: BuybackProduct) {
  const i18n = useI18n()
  const route = useRoute()
  const router = useRouter()
  const { protocol, hostname } = useRequestURL()

  const canonicalParams = {
    locale: route.params.locale,
    category: product.category,
    slug: product.slug,
  }

  // The category segment is decorative and can be stale, so consolidate it with a 301.
  if (
    route.params.slug !== product.slug ||
    route.params.category !== product.category
  ) {
    await navigateTo(
      {
        name: ROUTE_NAMES.TRADE_IN_PRODUCT,
        params: canonicalParams,
        query: route.query,
      },
      { redirectCode: 301 },
    )
  }

  const canonicalHref = `${protocol}//${hostname}${
    router.resolve({
      name: ROUTE_NAMES.TRADE_IN_PRODUCT,
      params: canonicalParams,
    }).href
  }`

  useHead({
    title: i18n(translations.productPageTitle, {
      productName: product.model,
      price: product.price ? i18n.price(product.price) : '',
    }),
    link: [
      {
        rel: 'canonical',
        href: canonicalHref,
      },
    ],
  })
}
